import axios from "../../utils/axios";

export const getTransactions = async ({ latest = false, page = 1 } = {}) => {
    let url = "/transactions"

    // ## I can't use this code because if i only get the latest 5 transactions, then it is impossible to calculate the current balance (for JSON Server limitation)
    // if (latest) {
    // url += "?_sort=id&_order=desc&_limit=5";
    // }

    // ## I can fetch data only for current page, but this is not required because I already have all transaction information for calculating balance.
    // if (!latest) {
    //     url += `?_page=${page}&_limit=5`
    // }

    const { data } = await axios.get(url);
    return data;
};

export const addTransaction = async (data) => {
    const response = await axios.post("/transactions", data);

    return response.data;
};

export const editTransaction = async (id, data) => {
    const response = await axios.put(`/transactions/${id}`, data);

    return response.data;
};

export const deleteTransaction = async (id) => {
    const response = axios.delete(`/transactions/${id}`);

    return response.data;
};
